import get from 'lodash.get';
import { MEASURE } from './MeasuresConstants';

export const FIRST_GRADE_INDEX = 0;
export const DROPDOWN_ITEMS_LENGTH_EQUAL_ONE = 1;
export const THREE_GRADES = 3;

export const GRADE = {
    PREKINDERGARTEN: 'PK',
    KINDERGARTEN: 'KG',
    FIRST_GRADE: '01',
    SECOND_GRADE: '02',
    THIRD_GRADE: '03',
    FOURTH_GRADE: '04',
    FIFTH_GRADE: '05',
    SIXTH_GRADE: '06',
    SEVENTH_GRADE: '07',
    EIGHTH_GRADE: '08',
    NINTH_GRADE: '09',
    TENTH_GRADE: '10',
    ELEVENTH_GRADE: '11',
    TWELFTH_GRADE: '12',
    ALL_GRADES: 'all',
};

export const GRADE_TITLE = [
    { key: GRADE.PREKINDERGARTEN, title: 'Prekindergarten' },
    { key: GRADE.KINDERGARTEN, title: 'Kindergarten' },
    { key: GRADE.FIRST_GRADE, title: 'Grade 1' },
    { key: GRADE.SECOND_GRADE, title: 'Grade 2' },
    { key: GRADE.THIRD_GRADE, title: 'Grade 3' },
    { key: GRADE.FOURTH_GRADE, title: 'Grade 4' },
    { key: GRADE.FIFTH_GRADE, title: 'Grade 5' },
    { key: GRADE.SIXTH_GRADE, title: 'Grade 6' },
    { key: GRADE.SEVENTH_GRADE, title: 'Grade 7' },
    { key: GRADE.EIGHTH_GRADE, title: 'Grade 8' },
    { key: GRADE.NINTH_GRADE, title: 'Grade 9' },
    { key: GRADE.TENTH_GRADE, title: 'Grade 10' },
    { key: GRADE.ELEVENTH_GRADE, title: 'Grade 11' },
    { key: GRADE.TWELFTH_GRADE, title: 'Grade 12' },
];

export const SUPPORTED_GRADES = [
    GRADE.KINDERGARTEN,
    GRADE.FIRST_GRADE,
    GRADE.SECOND_GRADE,
    GRADE.THIRD_GRADE,
    GRADE.FOURTH_GRADE,
    GRADE.FIFTH_GRADE,
    GRADE.SIXTH_GRADE,
];

export const UNSUPPORTED_GRADES = [
    GRADE.SEVENTH_GRADE,
    GRADE.EIGHTH_GRADE,
    GRADE.NINTH_GRADE,
    GRADE.TENTH_GRADE,
    GRADE.ELEVENTH_GRADE,
    GRADE.TWELFTH_GRADE,
];

export const ALL_GRADES = [
    GRADE.PREKINDERGARTEN,
    GRADE.KINDERGARTEN,
    GRADE.FIRST_GRADE,
    GRADE.SECOND_GRADE,
    GRADE.THIRD_GRADE,
    GRADE.FOURTH_GRADE,
    GRADE.FIFTH_GRADE,
    GRADE.SIXTH_GRADE,
    GRADE.SEVENTH_GRADE,
    GRADE.EIGHTH_GRADE,
    GRADE.NINTH_GRADE,
    GRADE.TENTH_GRADE,
    GRADE.ELEVENTH_GRADE,
    GRADE.TWELFTH_GRADE,
];

export const getGradeTitle = grade => {
    if (grade === GRADE.ALL_GRADES) return 'All Grades';
    const gradeObject = GRADE_TITLE.find(item => item.key === grade);
    return get(gradeObject, 'title', '');
};

export const getSupportedGrade = grade => {
    const { PREKINDERGARTEN, KINDERGARTEN, SIXTH_GRADE } = GRADE;
    if (SUPPORTED_GRADES.includes(grade)) return grade;
    if (grade === PREKINDERGARTEN) return KINDERGARTEN;
    return SIXTH_GRADE;
};

// important: request "/maze-api/v1/forms" expects grades KG|01|02|03|04|05|06 for MAZE
// added to espanol for consistency
export const basicComprehensionGradesMap = gradeToMeasureMapper => {
    const { MAZE, CLPL } = MEASURE;
    const GRADES_WITH_BC = [];
    const GRADES_WITHOUT_BC = [GRADE.PREKINDERGARTEN, ...SUPPORTED_GRADES];

    gradeToMeasureMapper.forEach(({ key, measures }) => {
        if (UNSUPPORTED_GRADES.includes(key)) return;

        if (key !== GRADE.FIRST_GRADE && measures.some(measure => [MAZE, CLPL].includes(measure))) {
            GRADES_WITH_BC.push(key);

            if (GRADES_WITHOUT_BC.includes(key)) {
                GRADES_WITHOUT_BC.splice(GRADES_WITHOUT_BC.indexOf(key), 1);
            }
        }
    });

    return { GRADES_WITH_BC, GRADES_WITHOUT_BC };
};
